module.exports = __webpack_public_path__ + "img/banner-hn.cacb1035.png";